import { map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports ----

import { prepareCustomers } from '~/store/customers/actions';
import { CUSTOMERS_SET_UP_CUSTOMER_PHASE } from '~/store/customers/actionTypes';
// ---- internal imports ----

const prepareCustomerEpic = (action$) => action$.pipe(
	ofType(CUSTOMERS_SET_UP_CUSTOMER_PHASE),
	map(() => prepareCustomers())
);

export default prepareCustomerEpic;
